import { trackInteraction, setupScrollAnalyticsTracking } from 'client/javascript/analytics';
import { sendBucketEvent } from 'client/javascript/heap';

const PRICE_SELECTOR = '.product-card__action';
const PRODUCT_CARD_SELECTOR = '.product-card ';

const priceHandlerClick = ({ target }) => {
  const card = target.closest(PRODUCT_CARD_SELECTOR);
  trackInteraction({
    label: 'Building Page Click Reservable Starting Price',
    amount: card.dataset.amount,
    currency: card.dataset.currency,
    reservable_type: card.dataset.reservable_type
  });
};

export const setupBuildingsAnalytics = () => {
  const cards = document.querySelectorAll(PRICE_SELECTOR);
  cards.forEach(priceElement => priceElement.addEventListener('click', priceHandlerClick));
};

export function setupOnDemandExperiment() {
  const onDemandHeaderClass = '.on-demand-header';
  const hasOnDemand = !!document.querySelector(onDemandHeaderClass);
  if (!hasOnDemand) {
    return;
  }
  sendBucketEvent('onDemandLink', { customLabel: 'On Demand Web Funnel' });

  const onDemandDayPassCardSelector = document.querySelector('.product-card.on-demand-day-pass-card');
  const onDemandConfRoomCardSelector = document.querySelector('.product-card.on-demand-conference-room-card');

  onDemandDayPassCardSelector.addEventListener('click', () => {
    trackInteraction({
      label: 'Click - On Demand Day Pass'
    });
  });

  onDemandConfRoomCardSelector.addEventListener('click', () => {
    trackInteraction({
      label: 'Click - On Demand Conference Rooms'
    });
  });

  setupScrollAnalyticsTracking({
    label: 'Scroll - Viewed On Demand Options',
    selector: onDemandHeaderClass
  });
}
